import React, { useEffect } from "react";
import { useTable, useRowSelect, useExpanded } from "react-table";

const CustomTable = ({
  data,
  columns,
  showCheckboxes = false,
  onCheckboxSelect,
  centerAlignedColumns = [],
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
    },
    useExpanded,
    useRowSelect,
    (hooks) => {
      if (showCheckboxes) {
        hooks.visibleColumns.push((columns) => [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <input
                type="checkbox"
                {...getToggleAllRowsSelectedProps()}
                style={{ cursor: "pointer" }}
              />
            ),
            Cell: ({ row }) => (
              <input
                type="checkbox"
                {...row.getToggleRowSelectedProps()}
                style={{ cursor: "pointer" }}
              />
            ),
          },
          ...columns,
        ]);
      }
    }
  );

  useEffect(() => {
    if (onCheckboxSelect) {
      onCheckboxSelect(selectedFlatRows);
    }
  }, [onCheckboxSelect, selectedFlatRows]);

  return (
    <div>
      <table
        {...getTableProps()}
        className="custom-table font-size-small font-family-medium"
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className={`table-header ${
                    centerAlignedColumns.includes(column.id)
                      ? "center-aligned"
                      : ""
                  }`}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="bg-[var(--whiteColor)]">
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to show
              </td>
            </tr>
          ) : (
            rows.map((row) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  className={row.id.includes(".") ? "bg-[#EAEAEA]" : ""}
                >
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      className={`table-cell ${
                        centerAlignedColumns.includes(cell.column.id)
                          ? "center-aligned"
                          : ""
                      }`}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CustomTable;
